// 获取系统语言
import { Lang } from '@/store/types';

export function getLang() {
    // getAppLanguageSync 仅在安卓下可用
    try {
        let lang = Lang.zhCN;
        let langStr = '';
        if (navigator && navigator.language) {
            console.log('navigator', langStr);
            langStr = navigator.language;
        }
        langStr = langStr.toLowerCase();
        // 解决 zh-TW 类似的。 只要是中文 或者藏语 ，全部采用简体（目前只做简体 和 英文适配） ug-CN 维吾尔
        lang =
            langStr.includes('zh') ||
            langStr === 'bo-cn' ||
            langStr === 'bo' ||
            langStr === 'ug' ||
            langStr === 'ug-cn'
                ? Lang.zhCN
                : Lang.enUS;
        console.log('获取系统语言', lang);
        return lang;
    } catch (e) {
        console.log(e);
    }
    return Lang.zhCN;
}
